import { css as _css } from "@emotion/core";

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

import React from "react";
import PropTypes from "prop-types";
import useTheme from "../hooks/useTheme";
import { jsx as ___EmotionJSX } from "@emotion/core";

function Twitter(_ref) {
  var size = _ref.size,
      primaryColor = _ref.primaryColor,
      hoverColor = _ref.hoverColor,
      testId = _ref.testId;
  var theme = useTheme();
  return ___EmotionJSX("svg", {
    css: /*#__PURE__*/_css({
      display: "block",
      fill: primaryColor,
      transition: hoverColor ? theme.transitions.icon : null,
      ":hover": _objectSpread({}, hoverColor && {
        fill: hoverColor
      })
    }, process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"),
    width: size,
    height: size,
    viewBox: "0 0 32 32",
    focusable: "false",
    role: "img",
    "data-testid": testId
  }, ___EmotionJSX("path", {
    d: "M4 16c0 6.628 5.373 12 12 12 6.628 0 12-5.372 12-12S22.628 4 16 4C9.373 4 4 9.372 4 16zm12.246-2.238a2.894 2.894 0 012.892-2.892 2.88 2.88 0 012.112.912 5.872 5.872 0 001.836-.701 2.889 2.889 0 01-1.272 1.601 5.872 5.872 0 001.662-.456 5.931 5.931 0 01-1.446 1.501c.006.119.006.245.006.371 0 3.823-2.91 8.232-8.232 8.232a8.06 8.06 0 01-4.422-1.308 5.816 5.816 0 004.284-1.194 2.889 2.889 0 01-2.7-2.01 2.843 2.843 0 001.308-.048 2.897 2.897 0 01-2.322-2.838v-.036c.39.216.834.348 1.308.36a2.88 2.88 0 01-1.29-2.406c0-.528.144-1.026.39-1.452a8.208 8.208 0 005.964 3.024 2.651 2.651 0 01-.078-.66z",
    fillRule: "evenodd"
  }));
}

Twitter.propTypes = {
  size: PropTypes.string.isRequired,
  primaryColor: PropTypes.string.isRequired,
  hoverColor: PropTypes.string,
  testId: PropTypes.string
};
export default Twitter;